var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCancelInput(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#8A93A0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.08785 6.0876C6.31565 5.8598 6.685 5.8598 6.9128 6.0876L10.0003 9.17512L13.0878 6.0876C13.3157 5.8598 13.685 5.8598 13.9128 6.0876C14.1406 6.31541 14.1406 6.68475 13.9128 6.91256L10.8253 10.0001L13.9128 13.0876C14.1406 13.3154 14.1406 13.6848 13.9128 13.9126C13.685 14.1404 13.3157 14.1404 13.0878 13.9126L10.0003 10.825L6.9128 13.9126C6.685 14.1404 6.31565 14.1404 6.08785 13.9126C5.86004 13.6848 5.86004 13.3154 6.08785 13.0876L9.17537 10.0001L6.08785 6.91256C5.86004 6.68475 5.86004 6.31541 6.08785 6.0876Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelInput);
export default __webpack_public_path__ + "static/media/cancel-input.6209f779f435bf05072aa6370a7a4bee.svg";
export { ForwardRef as ReactComponent };